export enum EntityClass {
  AG_ARBEITSZEIT = 'AGArbeitszeit',
  AG_BERUFSGENOSSENSCHAFT = 'AGBerufsgenossenschaft',
  AG_FIRMENFAHRZEUG = 'AGFirmenFahrzeug',
  AG_INFOS = 'AGInfos',
  AG_KUNDENINDIVIDUELLEINFORMATIONEN = 'AGKundenindividuelleInformationen',
  AG_LOHNGEHALTSZAHLUNGEN = 'AGLohnGehaltszahlungen',
  AG_SONDERZAHLUNGEN = 'AGSonderzahlungen',
  AG_VERTRAGSINFOS = 'AGVertragsInfos',
  BESCHAEFTIGUNGS_GENEHMIGUNG = 'BeschaeftigungsGenehmigung',
  AG_BESCHAFTIGUNG = 'AGBeschaftigung',
  AG_AUSLAND_BESCHAFTIGUNG = 'AGAuslandBeschaftigung',
  ZAHLUNG = 'Zahlung',
  AN_ABGESCHLOSSSEN = 'ANAbgeschlosssen',
  ADRESSE = 'Adresse',
  AN_GERINGFUEGIGEBESCHAEFTIGUNG = 'AN_GERINGFUEGIGEBESCHAEFTIGUNG',
  AN_AUSBILDUNG = 'ANAusbildung',
  BANK_INFOS = 'BankInfos',
  AN_DOKUMENTE = 'ANDokumente',
  AN_PERSONALAKTE = 'ANPersonalakte',
  AN_EINVERSTAENDNISERKLAERUNGEN = 'ANEinverstaendnisErklaerungen',
  AN_INFOS = 'ANInfos',
  AN_BESCHAEFTIGUNG = 'ANBeschaeftigung',
  STAMMDATEN = 'Stammdaten',
  AN_PRIVATVERSICHERUNG = 'ANPrivatVersicherung',
  AN_SCHWERBEHINDERUNG = 'ANSchwerbehinderung',
  AN_SOZIALVERSICHERUNG = 'ANSozialVersicherung',
  AN_STEUERINFOS = 'ANSteuerInfos',
  AN_VERMOEGENSSICHERUNG = 'ANVermoegenssicherung',
  AN_PERSOENLICHE_DATEN_TEILEN = 'ANPersoenlicheDatenTeilen',
  AN_VERMOEGENSWIRKSAMELEISTUNGEN = 'ANVermoegenswirksameLeistungen',
  NACHTRAG_ARBEITSZEIT = 'NachtragArbeitszeit',
  NACHTRAG_INFOS = 'NachtragInfos',
  NACHTRAG_LOHNGEHALTSZAHLUNGEN = 'NachtragLohnGehaltszahlungen',
  NACHTRAG_SONDERZAHLUNGEN = 'NachtragSonderzahlungen',
  NACHTRAG_VERTRAGSINFOS = 'NachtragVertragsInfos',
  NACHTRAG_EINGRUPPIERUNG = 'NachtragEingruppierung',
  NACHTRAG_EINGRUPPIERUNG1 = 'NachtragEingruppierung1',
  NACHTRAG_EINGRUPPIERUNG2 = 'NachtragEingruppierung2',
  ABWESENHEIT = 'Abwesenheit',
  ADDRESSAUTOCOMPLETE = 'AddressAutocomplete',
  ENTITYVERSIONDISPLAY = 'EntityVersionDisplay',
  NACHTRAG = 'Nachtrag',
  NUTZERSEKTION = 'NutzerSektion',
  ARBEITNEHMERSEKTION = 'ArbeitnehmerSektion',
  ARBEITGEBERSEKTION = 'ArbeitgeberSektion',
  NACHTRAGSEKTION = 'NachtragSektion',
  SCHULE = 'Schule',
  SG_USER = 'SGUser',
  SCHUELER = 'Schueler',
  VERTRAG = 'Vertrag',
  PATCHDISPLAY = 'PatchDisplay',
  URLAUB = 'Urlaub',
  KRANKHEIT = 'Krankheit',
  KRANKHEIT_OHNE_AU = 'KrankheitOhneAU',
  KRANKHEIT_MIT_AU = 'KrankheitMitAU',
  KIND_KRANK = 'KindKrank',
  MUTTERSCHUTZ = 'Mutterschutz',
  ELTERNZEIT = 'Elternzeit',
  SABBATICAL = 'Sabbatical',
  ALTERSTEILZEIT = 'Altersteilzeit',
  UNBEZAHLTER_URLAUB = 'UnbezahlterUrlaub',
  BESCHAEFTIGUNGSVERBOT = 'Beschaeftigungsverbot',
  FORTBILDUNG = 'FORTBILDUNG',
  DIENSTLICHE_BEURLAUBUNG = 'DienstlicheBeurlaubung',
  KLASSENFAHRT = 'Klassenfahrt',
  EXKURSION = 'Exkursion',
  DIENST_AM_ANDEREN_ORT = 'DienstAmAnderenOrt',
  LEHRPROBE = 'Lehrprobe',
  INTERNER_EINSATZ = 'InternerEinsatz',
  SOZIALPRAKTIKUM = 'Sozialpraktikum',
  FREIE_STUDIEN = 'FreieStudien',
  ABITURPRUFUNGEN = 'Abiturprufungen',
  ELTERNZEIT_TEILZEIT = 'EltenzeitTeilzeit',
  ALTERSTEILZEIT_AKTIV = 'AltersteilzeitAktiv',
  ALTERSTEILZEIT_PASSIV = 'AltersteilzeitPassiv',
  VOLLE_ERWERBSMINDERUNGS_RENTE = 'VolleErwerbsminderungsRente',
  SONDERURLAUB = 'Sonderurlaub',
  REHA = 'Reha',
  VOLL_FREIGESTELLT_PFLEGE = 'VollFreigestelltPflege',
  BESTELLUNG = 'Bestellung',
  PRODUKT = 'Produkt',
  BUCHUNG = 'Buchung',
  SCHULGELD = 'Schulgeld',
  ESSENSGELD = 'Essensgeld',
  BETREUUNG = 'Betreuung',
  PARKPLATZ = 'Parkplatz',
  MUSIKUNTERRICHT = 'Musikunterricht',
  KOSTENSTELLE = 'Kostenstelle',
  PRODUKT_ZUWEISUNG = 'ProduktZuweisung',
  SCHULGELD_ZUWEISUNG = 'SchulgeldZuweisung',
  ESSENSGELD_ZUWEISUNG = 'EssensgeldZuweisung',
  BETREUUNG_ZUWEISUNG = 'BetreuungZuweisung',
  PARKPLATZ_ZUWEISUNG = 'ParkplatzZuweisung',
  MUSIKUNTERRICHT_ZUWEISUNG = 'MusikunterrichtZuweisung',
  KLASSENFAHRT_ZUWEISUNG = 'KlassenfahrtZuweisung',
  KOSTENSTELLEPROZENTSATZ = 'KostenstelleProzentsatz',
  SG_CONFIG = 'SGConfig',
  PROFIL_DATEN = 'ProfilDaten',
  PERSON = 'Person',
  MITARBEITER_DATEN = 'MitarbeiterDaten',
  PROFIL_SEKTION_PARENT = 'ProfilSektionParent',
  DOWNLOADS = 'Downloads',
  GRUPPE = 'Gruppe',
  MICROSOFTGRUPPE = 'MicrosoftSynchedGroup',
  SCHULGRUPPE = 'SchulGruppe',
  SCHULUEBERGREIFENDEGRUPPE = 'SchulUebergreifendeGruppe',
  QUITTUNG = 'Quittung',
  SPENDE = 'Spende',
  KONTOAUSZUG = 'Kontoauszug',
  AG_ARBEIT = 'AGArbeit',
  AG_KRANKENVERSICHERUNG = 'AGKrankenversicherung',
}
